module.exports = __webpack_public_path__ + "static/img/gghlogo.5ab1280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gghlogo.jpg
// module id = rTKU
// module chunks = 42